import {
  AnyObject,
  createLinkPlugin,
  createPlateUI,
  createPlugins,
  createTEditor,
  ELEMENT_LINK,
  PlateEditor,
  PlatePlugin,
  Value,
  withPlate,
} from '@udecode/plate';
import React, { useMemo, useRef } from 'react';
import styled from 'styled-components';

import linkifyIt from '@ad-scripts/presentation/components/lib/linkify_it';
import { isUrlValid } from '@ad-scripts/presentation/components/lib/linkify_it';
import { EditorFloatingLink } from './EditorFloatingLink';
import { withLink } from './withLink';

export const linkPlugin = createLinkPlugin({
  renderAfterEditable: EditorFloatingLink,
  withOverrides: withLink,
  options: {
    // Automatically transform things that look like links into actual links. Maybe not desired but..
    getUrlHref: getNormalizedUrl,
    isUrl(text) {
      return isUrlValid(text);
    },
  },
});

const getPlugins = (extraPlugins: PlatePlugin<AnyObject, Value, PlateEditor<Value>>[] = []) =>
  createPlugins([linkPlugin, ...extraPlugins], {
    components: createPlateUI({
      [ELEMENT_LINK]: props => <StyledLink {...props} />,
    }),
  });

export function getNormalizedUrl(url) {
  if (!url) {
    return '';
  }
  const matches = linkifyIt.match(url);
  if (!matches) {
    return undefined;
  }

  return (matches && matches[0].url) || url;
}

export default function useEditorRef(id: string, plugins: PlatePlugin<AnyObject, Value, PlateEditor<Value>>[] = []) {
  const editor = useMemo(() => {
    return withPlate(createTEditor(), { id, plugins: getPlugins(plugins) });
  }, [id, plugins]);

  return useRef(editor);
}

export const StyledLink = styled.a`
  color: ${p => p.theme.colors.green400};
  text-decoration: underline;
  &:hover {
    color: ${p => p.theme.colors.green400};
    text-decoration: underline;
  }
`;
